(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colorcolar-home-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-intro-carousel')) {
    class CcIntroCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-cc-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-cc-dot]'));
        this.previousButton = this.querySelector('[data-cc-prev]');
        this.nextButton = this.querySelector('[data-cc-next]');
        this.toggleButton = this.querySelector('[data-cc-toggle]');
        this.pauseIcon = this.querySelector('[data-cc-pause-icon]');
        this.playIcon = this.querySelector('[data-cc-play-icon]');
        this.status = this.querySelector('[data-cc-status]');
        this.index = Math.max(this.slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
        this.interval = Math.max(Number(this.dataset.interval) || 4000, 3000);
        this.userPaused = this.dataset.autoplay !== 'true';
        this.hovered = false;
        this.focused = false;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };

        if (this.slides.length < 2) return;

        this.previousButton?.addEventListener('click', () => this.move(-1, true), options);
        this.nextButton?.addEventListener('click', () => this.move(1, true), options);
        this.toggleButton?.addEventListener('click', () => this.toggleAutoplay(), options);
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.show(index, true);
            this.schedule();
          }, options);
        });
        this.addEventListener('mouseenter', () => {
          this.hovered = true;
          this.stop();
        }, options);
        this.addEventListener('mouseleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.stop();
        }, options);
        this.addEventListener('focusout', () => {
          window.requestAnimationFrame(() => {
            this.focused = this.contains(document.activeElement);
            this.schedule();
          });
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selectedIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selectedIndex < 0) return;
          this.userPaused = true;
          this.show(selectedIndex, false);
          this.updateToggle();
          this.stop();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motionPreference.addEventListener('change', () => {
          this.updateToggle();
          this.schedule();
        }, options);

        this.show(this.index, false);
        this.updateToggle();
        this.schedule();
      }

      disconnectedCallback() {
        this.stop();
        this.abortController?.abort();
        this.initialized = false;
      }

      canPlay() {
        return !this.userPaused && !this.hovered && !this.focused && !document.hidden && !this.motionPreference.matches;
      }

      stop() {
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      schedule() {
        this.stop();
        if (!this.canPlay()) return;
        this.timer = window.setTimeout(() => {
          this.show(this.index + 1, false);
          this.schedule();
        }, this.interval);
      }

      move(delta, announce) {
        this.show(this.index + delta, announce);
        this.schedule();
      }

      show(nextIndex, announce) {
        const normalizedIndex = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const isActive = index === normalizedIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
        this.dots.forEach((dot, index) => {
          const isActive = index === normalizedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });
        this.index = normalizedIndex;
        if (announce && this.status) {
          const title = this.slides[this.index].querySelector('.cc-intro__slide-title')?.textContent?.trim();
          this.status.textContent = title ? `${this.index + 1} di ${this.slides.length}: ${title}` : `${this.index + 1} di ${this.slides.length}`;
        }
      }

      toggleAutoplay() {
        this.userPaused = !this.userPaused;
        this.updateToggle();
        this.schedule();
      }

      updateToggle() {
        if (!this.toggleButton) return;
        this.toggleButton.hidden = this.motionPreference.matches;
        this.toggleButton.setAttribute('aria-pressed', String(this.userPaused));
        this.toggleButton.setAttribute('aria-label', this.userPaused ? 'Avvia rotazione automatica' : 'Pausa rotazione automatica');
        if (this.pauseIcon) this.pauseIcon.hidden = this.userPaused;
        if (this.playIcon) this.playIcon.hidden = !this.userPaused;
      }
    }

    customElements.define('cc-intro-carousel', CcIntroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
